import axios from "../utils/axios";
import { decryptData, saveData, postErrorSlack } from '../utils/index.jsx';
import * as jose from 'jose';
import CryptoJS from 'crypto-js';

export function fetchUser(){
    return new Promise((resolve, reject) => {
        axios.get(import.meta.env.VITE_APP_API_URL+'/researcher/validate', { headers: {"Authorization" : localStorage.getItem("jwt")}})
            .then((response) => {
                if (response.status === 200) {
                    resolve(true);
                } else {
                    // Handle non-200 status codes (401, 403, etc.)
                    // Since axios.validateStatus treats < 500 as success, we need to handle them here
                    let errorReason = "Unknown error";
                    let errorDetails = {};
                    
                    const status = response.status;
                    if (status === 401) {
                        errorReason = "Unauthorized - Invalid or expired JWT token";
                    } else if (status === 403) {
                        errorReason = "Forbidden - User does not have permission";
                    } else if (status >= 400) {
                        errorReason = `Client Error (${status}) - Bad request`;
                    } else {
                        errorReason = `HTTP Error (${status}) - Unexpected status code`;
                    }
                    errorDetails = {
                        status: status,
                        statusText: response.statusText,
                        data: response.data,
                        type: "http_error"
                    };
                    
                    // Send Slack notification with error details
                    const userInfo = localStorage.getItem("jwt") ? 
                        (() => {
                            try {
                                const payload = jose.decodeJwt(localStorage.getItem("jwt"));
                                return `User: ${payload.email || payload.uuid || "Unknown"}`;
                            } catch (e) {
                                return "User: Unable to decode JWT";
                            }
                        })() : 
                        "User: No JWT token";
                    
                    const slackMessage = `🔴 fetchUser Validation Failed\n\n` +
                        `Reason: ${errorReason}\n` +
                        `${userInfo}\n` +
                        `URL: ${window.location.href}\n` +
                        `Details: ${JSON.stringify(errorDetails)}`;
                    
                    postErrorSlack("auth/fetchUser", slackMessage, errorDetails, null);
                    
                    resolve(false);
                }
            })
            .catch(err => {
                console.log('Catch', err);
                
                // Determine the reason for the failure
                let errorReason = "Unknown error";
                let errorDetails = {};
                
                if (!err.response) {
                    // Check for CORS error first (status 0 or specific error patterns)
                    if (err.code === 0 || 
                        err.response?.status === 0 || 
                        err.message?.toLowerCase().includes('cors') ||
                        err.message?.toLowerCase().includes('cross-origin') ||
                        err.message === "Failed to fetch" ||
                        (err.request && err.request.status === 0)) {
                        errorReason = "CORS Error - Cross-origin request blocked by browser. Server may be missing CORS headers.";
                        errorDetails = {
                            message: err.message,
                            code: err.code,
                            status: err.response?.status || err.request?.status || 0,
                            type: "cors_error"
                        };
                    }
                    // Network error - no response from server
                    else if (err.message === "Network Error" || err.code === "ERR_NETWORK") {
                        errorReason = "Network Error - No internet connection or server unreachable";
                        errorDetails = {
                            message: err.message,
                            code: err.code,
                            type: "network_error"
                        };
                    } else if (err.code === "ECONNREFUSED") {
                        errorReason = "Connection Refused - Server is down or not accepting connections";
                        errorDetails = {
                            message: err.message,
                            code: err.code,
                            type: "network_error"
                        };
                    } else if (err.code === "ETIMEDOUT" || err.message?.includes("timeout")) {
                        errorReason = "Request Timeout - Server took too long to respond";
                        errorDetails = {
                            message: err.message,
                            code: err.code,
                            type: "network_error"
                        };
                    } else {
                        errorReason = `Network Error - ${err.message || err.code || "Unknown network issue"}`;
                        errorDetails = {
                            message: err.message,
                            code: err.code,
                            type: "network_error"
                        };
                    }
                } else {
                    // HTTP error - server responded with error status
                    const status = err.response.status;
                    if (status === 401) {
                        errorReason = "Unauthorized - Invalid or expired JWT token";
                    } else if (status === 403) {
                        errorReason = "Forbidden - User does not have permission";
                    } else if (status >= 500) {
                        errorReason = `Server Error (${status}) - Internal server error`;
                    } else if (status >= 400) {
                        errorReason = `Client Error (${status}) - Bad request`;
                    } else {
                        errorReason = `HTTP Error (${status}) - Unexpected status code`;
                    }
                    errorDetails = {
                        status: status,
                        statusText: err.response.statusText,
                        data: err.response.data,
                        type: "http_error"
                    };
                }
                
                // Send Slack notification with error details
                const userInfo = localStorage.getItem("jwt") ? 
                    (() => {
                        try {
                            const payload = jose.decodeJwt(localStorage.getItem("jwt"));
                            return `User: ${payload.name + " " + payload.surnames + " " + payload.uuid || "Unknown"}`;
                        } catch (e) {
                            return "User: Unable to decode JWT";
                        }
                    })() : 
                    "User: No JWT token";
                
                const slackMessage = `🔴 fetchUser Validation Failed\n\n` +
                    `Reason: ${errorReason}\n` +
                    `${userInfo}\n` +
                    `URL: ${window.location.href}\n` +
                    `Details: ${JSON.stringify(errorDetails)}`;
                
                postErrorSlack("auth/fetchUser", slackMessage, errorDetails, null);
                
                reject(err);
            }); 
    });
}

export function signIn(credentials, typeUser) {
  return new Promise((resolve, reject) => {
    saveData("password", credentials.password); 
    console.log("Pass", credentials.password);
    credentials.password = CryptoJS.SHA256(credentials.password).toString(CryptoJS.enc.Base64) 
    console.log("Pass Encr", credentials.password);
    axios.post(import.meta.env.VITE_APP_API_URL+'/'+typeUser+'/login', credentials)
        .then((response) => {
            if(response.status === 200){
                console.log("TOKEN: "+response.data.jwt);
                saveData("jwt", response.data.jwt);
                saveData("type", typeUser);
                const payload = jose.decodeJwt(localStorage.getItem("jwt"));
                const rawKeyResearcher = decryptData(payload.keyResearcher, localStorage.getItem("password"));
                saveData("rawKeyResearcher", rawKeyResearcher);
                saveData("name", payload.name);
                saveData("surnames", payload.surnames);
                saveData("uuid", payload.uuid);
                axios.defaults.headers['Authorization'] = localStorage.getItem('jwt');
                resolve(response.data);
            }
            else{
                reject(response.data);
            }
        })
        .catch(err => {console.log('Catch', err); reject(err);}); 
  });
}

export function signUp(credentials) {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/auth/sign-up", credentials)
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function resetPassword(credentials) {
  return new Promise((resolve, reject) => {
    axios
      .post("/api/auth/reset-password", credentials)
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
